/* power.on.svg.js */

"use strict";
module.exports = {
    icon: `
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <g>
                <title>Layer 1</title>
                <ellipse fill-opacity="0" stroke="#000" stroke-width="6%" ry="45%" rx="45%" id="svg_1" cy="50%" cx="50%" fill="#fff"/>
                <ellipse class="power-indicator" stroke="#000" ry="25%" rx="25%" id="svg_2" cy="50%" cx="50%" stroke-width="4%" fill="#84D3DB"/>
            </g> 
        </svg>
    `,
};
